import { Modal, ModalSize } from 'components/modal/Modal';
import useMediaQueries from 'hooks/useMediaQueries';
import React, { useState } from 'react';

interface Props {
    brandName: string;
    timeframeMessage: string;
    earningsPercentage: string; // e.g., "10%"
    brandLogo: string; // URL or import of the logo image
    isOpen: boolean;
    onClose: () => void;
}

const AffiliateConfirmationModal = ({
    brandName,
    timeframeMessage,
    earningsPercentage,
    brandLogo,
    isOpen,
    onClose,
}: Props) => {
    const [isMobile, setIsMobile] = useState(false);

    useMediaQueries({
        '(max-width: 500px)': () => setIsMobile(true),
        '(min-width: 501px)': () => setIsMobile(false),
    });

    return (
        <Modal
            title=""
            titleStyles="hidden"
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={true}
            size={[ModalSize.EXTRA_SMALL, ModalSize.MEDIUM]}
        >
            <div className="text-center p-6">
                {/* Brand Logo */}
                <img
                    src={brandLogo}
                    alt={`${brandName} logo`}
                    className="mx-auto"
                    style={{ height: isMobile ? '48px' : '64px' }}
                />
                {/* Earnings Title */}
                <h2 className="text-xl md:text-2xl font-bold text-brand-dark mb-2 mt-4">
                    {earningsPercentage} Shop Online Earnings
                </h2>
                {/* Message */}
                <p className="text-base text-grey-darkest mb-6">
                    If you made a purchase at {brandName}, you’ll receive an email{' '}
                    {timeframeMessage}
                </p>
                {/* Close Link */}
                <button
                    onClick={onClose}
                    className="text-lg text-brand underline font-semibold hover:text-brand-dark focus:text-brand-dark outline-none focus:outline-none"
                >
                    Close
                </button>
            </div>
        </Modal>
    );
};

export default AffiliateConfirmationModal;
